<template>
    <div>
        <main-navigation></main-navigation>
  <base-card>
    <!-- <input type="text" v-model="search" placeholder="Search students" /> -->
    <div id="element-to-convert">
    <!-- <img width="100" height="50" src="../../assets/NMC.png" /> -->
  
   <small> <table class="table table-sm">
      <thead>
        <tr>
          <th>Institution Name</th>
          <th>Number of students</th>
          <!-- <th><h3>Parent name</h3></th>
          <th><h3>phone number</h3></th> -->
          
        </tr>
      </thead>
      <tbody>
        <tr v-for="school in secondarySchools" :key="school.id">
          <td> <router-link
            :to="`/school/name/${school.the_code}`"
          >
            {{ school.school_name }}
          </router-link> </td> 
          <td>
            {{ school.numberofstudents }}
          </td>
          
        </tr>
      
      </tbody>
    </table>
</small>
    </div>
    <button @click="exportToPDF">Export to PDF</button>
    <br>
    <router-link to="/">Go back</router-link>
</base-card>
  </div>

  </template>
  <script>
  import html2pdf from 'html2pdf.js'
  
  
  
  export default {
    methods: {
      exportToPDF() {
              html2pdf(document.getElementById('element-to-convert'));
          }
  
  
    },
    data() {
      return {
        search: "",
      };
    },
    computed: {
      secondarySchools() {
        return this.$store.getters.secondarySchools;
      },
      
    },
    created() {
      this.$store.dispatch("LoadSecondaryschools");
      console.log(this.secondarySchools)
    },
  };
  </script>
  <style scoped>
  input {
    /* display: block; */
    width: 350px;
    margin: 20px auto;
    padding: 10px 45px;
    background: white no-repeat 15px center;
    background-size: 15px 15px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  }
  </style>
  